import { Typography } from '@mui/material'
import theme from 'lib/theme'
import React from 'react'
import { ORDER_STATUS } from 'types/api/order'
import { useRoutePlanning } from 'providers/RoutePlanningProvider'
import { MarkerInfo } from 'types/api/delivery'
import { MapMarkerTitle } from './elements'

type Props = {
  order: MarkerInfo
  latlng: string
}

export const RouteMarkerContent = ({ order, latlng }: Props) => {
  const { selectedOrders, markerHovered, setMarkerHovered, setSelectedOrders } =
    useRoutePlanning()
  const selected = selectedOrders.find(
    (selected) => selected.orderId === order.orderId
  )

  const handleSelect = (id: string, deliveryId: number) => {
    if (order.status !== ORDER_STATUS.DELIVERED) {
      const idx = selectedOrders.findIndex(
        (selected) => selected.orderId === id
      )
      if (idx === -1) {
        setSelectedOrders((selectedOrders) => [
          ...selectedOrders,
          { orderId: id, deliveryId, latlng, routeName: order.routeName },
        ])
      } else {
        setSelectedOrders((selectedOrders) => selectedOrders.splice(idx, 1))
      }
    }
  }

  return (
    <MapMarkerTitle
      key={order.orderId}
      role='button'
      hovered={Boolean(selected || order.orderId === markerHovered?.id)}
      color={order.color}
      onClick={() => handleSelect(order.orderId, order.deliveryId)}
      onMouseOver={() => setMarkerHovered({ id: order.orderId, latlng })}
      onMouseOut={() => setMarkerHovered(null)}>
      <Typography variant='body2' sx={{ fontSize: '10px' }}>
        {order.routeName}
        {order.color !== theme.palette.text.primary &&
          `${order.routeNameIndex}`}
      </Typography>
    </MapMarkerTitle>
  )
}
